





























import { EventBus } from '@/plugins/event-bus';

import {Component, Prop, Vue} from "vue-property-decorator";
// @ts-ignore

const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
const recognition = SpeechRecognition? new SpeechRecognition() : false;
@Component
export default class SpeechToText extends Vue{
    @Prop({default: 'en-US', type: [String]}) readonly lang: string;
    @Prop({ required: true, type:[String, null]}) text: string | undefined | null;
    @Prop({default: false, required: false, type: [Boolean]}) practice: boolean;

    public error = '';
    public speaking =false ;
    public toggle = false;
    public runtimeTranscription = '';
    public sentences: any[] = [];



    checkCompatibility () {
        if (!recognition) {
            this.error = 'Speech Recognition is not available on this browser. Please use Chrome or Firefox'
        }
    }

    startSpeechRecognition () {
        if (!recognition) {
            this.error = 'Speech Recognition is not available on this browser. Please use Chrome or Firefox';
            return false
        }
        this.sentences = [];
        this.text = '';
        this.toggle = true;
        recognition.lang = this.lang;
        recognition.interimResults = true;

        recognition.start()
    }

    capitalizeFirstLetter (string: string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
    }

    endSpeechRecognition () {
        recognition.stop();
        this.toggle = false;
        this.$emit('speechend', {
            sentences: this.sentences,
            text: this.sentences.join(' ')
        })
    }

    mounted () {
        this.checkCompatibility();
        recognition.addEventListener('speechstart', () => {
            this.speaking = true
        });

        EventBus.$on('validate-response', ()=> {
            this.text = '';
            this.sentences = [];
            this.speaking = false;
            this.toggle = false
        });

        recognition.addEventListener('speechend', () => {
            this.speaking = false
        });

        recognition.addEventListener('result', (event: any) => {
            this.runtimeTranscription = Array.from(event.results).map((result: any) => result[0]).map(result => result.transcript).join('')
        });

        recognition.addEventListener('end', () => {
            if (this.runtimeTranscription !== '') {
                this.sentences.push(this.runtimeTranscription);
                this.$emit('update:text', `${this.text}${this.sentences.slice(-1)[0]}`)
            }
            this.runtimeTranscription = '';
            recognition.stop();
            this.speaking = false
            this.toggle = false

           // if (this.toggle) {
                // keep it going.
             //   recognition.start()
            //}
        });
    }


}
